import styled from "styled-components";

/**
 * Estilo do componente NavItem
 * Configura o layout e os estilos de interatividade do item.
 */
export const StyledNavItem = styled.li.withConfig({
  shouldForwardProp: (prop) => !["uppercase"].includes(prop),
})<{ uppercase: boolean }>`
  margin: 0;
  padding: ${({ theme }) => theme.spacing(1)} ${({ theme }) => theme.spacing(2)};
  color: ${({ theme }) => theme.colors.mediumGray};
  text-transform: ${({ uppercase }) => (uppercase ? "uppercase" : "none")};
  font-weight: ${({ theme }) => theme.fontWeights.normal};
  font-size: ${({ theme }) => theme.fontSizes.md};
  border: 1px solid ${({ theme }) => theme.colors.white};
  border-radius: ${({ theme }) => theme.borderRadius.small};
  position: relative; /* Necessário para posicionar o efeito ripple */
  overflow: hidden; /* Contém o efeito ripple dentro do botão */
  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
    color: ${({ theme }) => theme.colors.vividBlue};
    border-color: ${({ theme }) => theme.colors.vividBlue};

    @media (max-width: ${({ theme }) => theme.breakpoints.xxl}) {
      font-weight: ${({ theme }) => theme.fontWeights.bold};
      border-color: ${({ theme }) => theme.colors.white};
      border-bottom: 1px solid ${({ theme }) => theme.colors.vividBlue};
    }
  }

  /* Efeito ripple */
  &::after {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: ${({ theme }) => theme.colors.white};
    opacity: 0.4;
    transform: scale(0);
    border-radius: 50%;
    pointer-events: none;
    transition:
      transform 0.6s ease,
      opacity 0.6s ease;
  }

  &:active::after {
    transform: scale(4);
    opacity: 0;
  }
`;
